import React from 'react'
import { Helmet } from "react-helmet";
import "../../styles/SearchMap.css";
import KH_Image from "../../Images/kh_image_2-1.png";
import kleenhub_logo from "../../Images/plain_logo.png";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, IconButton, Modal, TextField } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { LoadingComponent } from '../../components/LoadingComponent';
import swal from 'sweetalert';
import moment from 'moment';
import EditIcon from '@mui/icons-material/Edit';
import { getHomeData, payForExtension, saveUserNameData } from '../../Services/Events.services';
import runOneSignal from '../../Utils/onesignal';
const webSiteUrl = 'https://kleenhub.com';

export const LoginHome = () => {
    const history = useNavigate();
    const [phoneNumber, setphoneNumber] = React.useState('');
    const [spinnerList, setSpinnerList] = React.useState(false);
    const [savedCup, setSavedCup] = React.useState('');
    const [borrowedData, setborrowedData] = React.useState('');
    const [savedData, setSavedData] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [name, setName] = React.useState(null);
    React.useEffect(() => {
        const token = localStorage.getItem("token");
        const phone = localStorage.getItem("phone");
        if (token && phone) {
            setphoneNumber(phone);
            getConsumerData();
            runOneSignal(phone);
        } else {
            history("/login");
        }
    }, []);

    const daysRemaining = (date) => {
        const diffDays = moment(date).diff(moment(), 'days');
        const diffHours = moment(date).diff(moment(), 'hours');
        const diffMinutes = moment(date).diff(moment(), 'minutes');
        if(diffDays === 0) {
            if(diffHours === 0) {
                return `${diffMinutes} minutes`;
            } else {
                return `${diffHours} hours ${((diffMinutes/60-diffHours)*60).toFixed(0)} minutes`;
            }
        } else {
            return `${diffDays+1} days`;
        }
    }

    const redirectToStatus = (productId) => {
        history(`/status/${productId}`);
    }

    const confirmPayment = (borrowId) => {
        swal({
            title: "Are you sure?",
            text: "By clicking ok you're confirming the payment from your account. The amount paid for borrow extension is non-refudable.",
            icon: "warning",
            buttons: [
                'No, cancel it!',
                'Yes, I am sure!'
            ],
            dangerMode: true,
        }).then(async (isConfirm) => {
            if (isConfirm){
                try {
                    setSpinnerList(true);
                    await payForExtension(borrowId);
                    await getConsumerData();
                    setSpinnerList(false);
                } catch (err) {
                    setSpinnerList(false)
                    swal('Error', err.response.data.message, 'error');
                }
            }
        });
    }

    const getConsumerData = async () => {
        try {
            setSpinnerList(true);
            const response = await getHomeData();
            if (response.status === 200) {
                const data = await response?.data;
                if (data) {
                    setSavedData(data.totalSave);
                    setSavedCup(data.productCategory);
                    setborrowedData(data.borrowData);
                    setName(data.name);
                }
            }
            setSpinnerList(false);
        } catch (err) {
            setSpinnerList(false)
            swal('Error', err.response.data.message, 'error');
        }
    };

    const onButtonClick = () => {
        localStorage.clear("token");
        localStorage.clear("phone");
        history("/login");
    }

    const saveUserName = async () => {
        await saveUserNameData(name);
        setOpen(false);
    }

    const addPayment = () => {
        history("/payment-methods");
    }

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    React.useEffect(() => {
        document.title = 'kleen hub - Home';  
    }, []);

    const borrowDataComponents = () => {
        return (
            borrowedData &&
            <>
                { borrowedData.length > 0 ?
                    <><strong> Currently Borrowed: </strong><br/></> :
                    <><strong>You have no packaging currently borrowed.</strong><br/></>
                }
                {
                    borrowedData?.map((item) => {
                        let amount = 3;
                        let unit = 'days';
                        if (item.extesionTimeSpan && item.extesionTimeSpan.length >= 2) {
                            amount = item.extesionTimeSpan.slice(0,-1);
                            unit = item.extesionTimeSpan.slice(-1) === 'd' ? 'days' : '';
                        }
                        let row1 = `${item.categoryName} - ${item.name}`;
                        let row2 = `Expiring in ${daysRemaining(item?.endDate)}.`;
                        let row3 = ` Extend by ${amount} ${unit} for ${item.extensionPrice} ${item.currency}.`
                        return (
                            <>
                                <a href="#" onClick={() => redirectToStatus(item.productId)} style={{ color: '#538103', textDecoration: 'underline' }}>
                                    <strong>
                                    {row1}
                                    </strong>
                                </a><br/>
                                {row2} <br/>
                                <a href="#" onClick={() => confirmPayment(item.id)} style={{ color: '#538103', textDecoration: 'underline' }}>
                                    <strong>
                                    {row3}
                                    </strong>
                                </a> <br/><br/>
                            </>
                        )
                    })
                }
            </>
        )
    }

    const savedDataComponents = () => {
        return (
            (savedCup && savedData) &&
            <>
                { savedCup.length > 0 ? <>So far you've saved </>: '' }
                {
                    savedCup?.map((item, index) => {
                        let savedCupString = '';
                        if (index === savedCup.length - 1 && index !== 0)
                            savedCupString += ' and ';
                        else if (index !== 0)
                            savedCupString += ', ';

                        savedCupString += `${item.numberOfBorrows} ${item.categoryName}`;
                        return (
                            <>
                                <strong>
                                    {savedCupString}
                                </strong>
                            </>
                        )
                    })
                }
                { savedCup.length > 0 ? (<>. <br/><br/> </>): '' }
                { savedData?.paper !== 0 ? <> In total you have saved an estimated <strong>{(savedData?.co2/1000).toFixed(2)} kg of CO2e,
                        {(savedData?.plastic/1000).toFixed(2)} kg of plastic and {(savedData?.paper/1000).toFixed(2)} kg of paper.</strong></> : ''
                }
            </>
        )
    }

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 300,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        borderRadius: '10px',
        boxShadow: 24,
        p: 4,
    };
    const handleTextChange = (e) => {
        setName(e.target.value);
    };

    const RegistrationSuccess = () => {
        return (phoneNumber && (
            <LoadingComponent loader={spinnerList}>
                <div style={{ maxWidth: '420px', position: 'absolute', maxHeight: '450px', 
                top: '0%', left: '50%', marginRight: '-50%', transform: 'translate(-50%, 0%)'}}>
                    <a className='title' style={{ maxWidth: '420px' }} target={'_blank'} rel={'noreferrer'} href={webSiteUrl}>
                        <img alt="KleenHub Logo" width={"13%"} style={{ filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.1))", minWidth: "83px" }} src={kleenhub_logo}/>
                    </a>
                    <div className="img1" style={{ position: 'relative', top: '-100px', height: '550px' }} id="first-page">
                        <img alt="KleenHub Logo" height={"100%"} width={"100%"} src={KH_Image}/>
                        <div className='div-text'>
                            <div id="oval_parent" className="multi-ellipse" style={{ top: '-160px', display: 'block' }}>
                                <div id="oval"></div>
                            </div>
                        </div>
                    </div>
                    <div className="vertical-center" style={{ display: 'block', position: 'relative' }}>
                        <p className='text-content-left' style={{ position: 'relative', marginTop: '-190px', textAlign: 'center', padding: '0px' }}>
                            Hej
                        </p>
                        <p className='text-content-left' style={{ position: 'relative', marginTop: '-35px', textAlign: 'center', padding: '0px' }}>
                            {name || phoneNumber}
                        </p>
                        <div className="vertical-left-edit" >
                            <IconButton aria-label="back" variant="outlined" color="success" onClick={handleOpen}>
                                <EditIcon fontSize='medium'/>
                            </IconButton>
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                                >
                                <Box sx={style}>
                                    <TextField margin="normal" color="success"
                                        label="Call me by" variant="outlined"
                                        inputProps={{ style: { textAlign: "center" } }}
                                        InputLabelProps={{
                                            style: { textAlign: 'center'},
                                        }}
                                        style={{ width: '300px' }}
                                        onChange={(e) => handleTextChange(e)}
                                    />
                                    <Button variant="outlined"
                                        style={{ backgroundColor: 'transparent', borderRadius: '10px', left: '33%', top: '10px', lineHeight: '1', width: "100px", height: "50px",
                                        fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                                        textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                                        disableRipple={true}
                                        onClick={saveUserName}
                                        >
                                            save
                                    </Button>
                                </Box>
                                </Modal>
                        </div>
                    </div>
                    <p className='text-content-right' style={{ position: 'relative', textAlign: 'center', padding: '25px', }}>          
                        {borrowDataComponents()}
                        <br/>
                        Thank you so much for being part of the movement and taking action towards a more sustainable future.
                    </p>         
                    <Accordion style={{ position: 'initial', boxShadow: 'none' }}>
                        <AccordionSummary>
                            <strong style={{ color: '#538103', textDecoration: 'underline', position: 'relative', left: '38%' }}>Your impact</strong>
                        </AccordionSummary>
                        <AccordionDetails>
                        <p className='text-content-right' style={{ position: 'relative', textAlign: 'center', padding: '25px', }}>          
                            {savedDataComponents()}
                        </p>
                        </AccordionDetails>
                    </Accordion>
                    <a href="/payment-methods" style={{ color: '#538103', textDecoration: 'underline', position: 'relative', left: '37%' }}>
                        <strong>
                        Edit payment
                        </strong>
                    </a>
                    <Button
                        style={{ backgroundColor: 'transparent', left: '20px', top: '50px', position: 'relative', lineHeight: '1', width: "160px", height: "68px",
                        fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                        textTransform: "none", color: '#538103' }}
                        disableRipple={true}
                        onClick={onButtonClick}
                        >
                            logout
                    </Button>
                    <div className="Footer">
                        <p>Contact us: care@kleenhub.com</p>
                    </div>
                </div>
            </LoadingComponent>
        ))
    }

    return (
        <div>
            <Helmet>
                <title>kleenhub</title>
            </Helmet>
            <div className='upcoming_leagues_background_img'>
                <div className='leagues_details'>
                </div>
            </div>
            {
                RegistrationSuccess()
            }
        </div>
    )
}
